import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
// === PROCESSO SELETIVO (temporário) — ver COMO-REMOVER-O-PS.md ===
import ProcessoSeletivo from './pages/ProcessoSeletivo';
import { psConfig } from './data/processoSeletivoData';
// === FIM PROCESSO SELETIVO ===

function App() {
  return (
    <BrowserRouter>
      <div className="App relative">
        <Routes>
          <Route path="/" element={<Home />} />

          {/* === PROCESSO SELETIVO (temporário) — ver COMO-REMOVER-O-PS.md ===
              Com psConfig.ativo = false, /inscricao devolve quem entrar para a home. */}
          <Route
            path="/inscricao"
            element={psConfig.ativo ? <ProcessoSeletivo /> : <Navigate to="/" replace />}
          />
          {/* === FIM PROCESSO SELETIVO === */}

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
